import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { changePassword } from '../../api/apiHandler';
import { useNavigate } from "react-router-dom";
import NavBar from '../../components/NavBar/NavBar';
import Heading from '../../components/Heading/Heading';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";


const schema = yup.object().shape({
    old_password: yup.string().required("Please enter old password"),
    password: yup.string().required("Please enter new password").matches(/^(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,"Password must contain at least 8 characters, one uppercase, one number and one special case character"),
    confirm_password: yup.string().required("Please enter confirm password").matches(/^(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,"Password must contain at least 8 characters, one uppercase, one number and one special case character").oneOf([yup.ref('password')], 'Password does not match'),
});


function Change_Password({isLoader}) {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const { register, handleSubmit, setValue, formState: { errors }, reset, clearErrors } = useForm({
        resolver: yupResolver(schema),
    });

    const initalValue = { opassword: "", password: "", cpassword: "" }
    const [formValues, setFormValues] = useState(initalValue);

    const [showpass, setShowpass] = useState(false);
    let navigate = useNavigate();


    const onSubmit = (data) => {
        isLoader(true);
        const donorId = localStorage.getItem("DAid");

        changePassword({ old_password: data.old_password, new_password: data.password,confirm_password: data.confirm_password,donor_id:donorId}).then((response) => {
            if(data.password === data.confirm_password){        
                if (response.data.code == 1) {
                isLoader(false);
                Swal.fire({
                    title:'Food For Good',
                    icon: 'success',
                    text: response.data.message,
                })
                reset();
                } else {
                    isLoader(false);
                    reset();
                }
            }else{
                isLoader(false);
                 Swal.fire({
                    title:'Food For Good',
                    icon: 'wrong',
                    text: 'new password & confirm password exactly not same',
                })
                reset();
            }
        });

    };

    return (
        <>
            <NavBar />
            <section className="content home">
                <Heading title="Change Password" />
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="body">
                                    <div className="row">
                                        <div className="details col-md-12">
                                            <form className="col-lg-12" onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group form-float">
                                                    <label className="form-label">Old Password</label>
                                                    <div className="form-line">
                                                        <input type="password" className="form-control" placeholder="Old Password" id="old_password" name="old_password" {...register("old_password")} />
                                                    </div>
                                                    <label className="errorc">{errors.old_password?.message}</label>
                                                </div>
                                                <div className="form-group form-float">
                                                    <label className="form-label">New Password</label>
                                                    <div className="form-line">
                                                        <input type="password" className="form-control" placeholder="New Password" id="password" name="password" {...register("password")} />
                                                    </div>
                                                    <label className="errorc">{errors.password?.message}</label>
                                                </div>
                                                <div className="form-group form-float">
                                                    <label className="form-label">Confirm Password</label>
                                                    <div className="form-line">
                                                        <input type="password" className="form-control" id="confirm_password" placeholder="Confirm Password" name="confirm_password" {...register("confirm_password")} />
                                                    </div>
                                                    <label className="errorc">{errors.confirm_password?.message}</label>
                                                </div>
                                                <div className="col-lg-12">
                                                    <button type="submit" className="btn btn-raised btn-primary waves-effect">Change Password</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default Change_Password;